import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { DropdownWrapper, DropdownMenu, DropdownItem } from "./styled";

const DropDownMenu = ({
  toggleComponent,
  items,
  $customStyles,
}: {
  toggleComponent: React.ReactNode;
  items: { label: string; onClick: () => void; style?: any }[];
  $customStyles?: any;  
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState<{
    top: number;
    right: number;
  } | null>(null);

  const menuRef = useRef<HTMLDivElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);

    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.top + window.scrollY, // Adjust for scrolling
        right: window.innerWidth - rect.left + window.scrollX, // Adjust for scrolling
      });
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target as Node)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const menu = dropdownOpen && menuPosition ? (
    <DropdownMenu
      ref={menuRef}
      sx={$customStyles}
      style={{
        top: `${menuPosition.top}px`,
        right: `${menuPosition.right}px`,
      }}
    >
      {items.map((item, index) => (
        <DropdownItem
          key={index}
          style={{ ...item.style }}
          onClick={(e) => {
            item.onClick();
            setDropdownOpen(false);
          }}
        >
          {item.label}
        </DropdownItem>
      ))}
    </DropdownMenu>
  ) : null;

  return (
    <div ref={wrapperRef} style={{ display: "inline-block" }}>
      <DropdownWrapper>
        <div onClick={toggleDropdown} style={{ cursor: "pointer" }}>
          {toggleComponent}
        </div>
      </DropdownWrapper>
      {createPortal(menu, document.body)}
    </div>
  );
};

export default DropDownMenu;
